import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import dayjs from "dayjs";
import { getScienceOfSelfSessions } from '../../../../../../redux/ScienceOfSelf/Scienceofselfslice';
import { Pagination } from "../../../../../../common/pagination";
import ModernPagination from "../../../../../../common/pagination/ModernPagination";
import Heading from '../../../../../../common/element/Heading';
import ClientInput from "../../../../../../common/element/Input/clientInput";
import BtnPrimary from "../../../../../../common/element/Buttons/btnPrimary";
import { debounce } from "../../../../../../common/snippet/Debouncing";
import { setBreadcrumbs } from "../../../../../../redux/Admin/breadcrumbsSlice";
import SessionList from './ScienceOfSelfList';
import AddEditSession from './AddSession';
import ToolManagmentCard from '../../../../../../common/element/Card/ToolManagmnetCard';
const SessionMaster = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const science_id = query.get('id');
  const [countData, setCountData] = useState(0);
  const [filterpage, setfilterpage] = useState(1);
  const [filterlimit, setfilterlimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const dispatch = useDispatch();
  const { data: sessionData, total: apiTotal, loading } = useSelector((state) => state.scienceOfSelf.getScienceOfSelfSessions);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [getFilterData, SetFilterData] = useState({
    function_assignment_id: "",
    page: 1,
    limit: 10,
    sort: "created_date",
    order: "desc",
    search: "",
  });

  // Search Data
  const handleSearch = (e) => {
    SetFilterData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value.trim(),
      };
    });
  };



  const inputchangehandler = useCallback(debounce(handleSearch), []);

  // Fetch sessions with filters
  useEffect(() => {
    if (science_id) {
      dispatch(getScienceOfSelfSessions({
        science_id,
        page: filterpage,
        limit: filterlimit,
        search: getFilterData.search
      }));
    }
  }, [dispatch, science_id, filterpage, filterlimit, getFilterData.search]);

  // Transform API data to match table format
  const formattedData = useMemo(() => {
    if (!sessionData || !Array.isArray(sessionData)) return [];

    return sessionData.map((item) => ({
      id: item.science_of_self_session_id,
      sessionName: item.session?.session_name || "-",
      dateTime: item.session_date ? dayjs(item.session_date).format("DD MMM YYYY") : "-",
      status: item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1) : "-",
      tool: item.session?.tool?.tool || "-",
      createdBy: "Admin", // Placeholder
assignment_enabled: item.assignment_enabled ,
      // Toggle states (assuming fields or defaulting to false as they are missing in sample response)
      supportedDocuments: item.document_status || false, // Mapping to potential field
      toolLockUnlock: item.tool_status || false,       // Mapping to potential field

      // Assignments
      assignment: (item.assignments && item.assignments.length > 0)
        ? item.assignments.map(a => a.assignment_name).join(", ")
        : "Send", 
      homeworkActivities: item.assignments || [],
      assignStatus: item.assign_status, // keeping original field for reference if needed
      tool_id: item.session?.tool?.id || null,
      raw: item
    }));
  }, [sessionData]);

  // Update pagination counts based on API total
  useEffect(() => {
    if (apiTotal !== undefined) {
      setCountData(apiTotal);
      setTotalPages(Math.ceil(apiTotal / filterlimit));
    }
  }, [apiTotal, filterlimit]);

  // Use formatted data directly as it's already filtered/paginated by API
  const filteredData = formattedData;

  const handlePageChange = (page) => {
    setfilterpage(page);
  };



  return (
    <React.Fragment>
      <ToolManagmentCard>  <div>
        <p className="text-gray-600 my-3"></p>
      </div>

        <div className="flex justify-between mb-5">
          <div className="w-80 h-10 text-start">
            <h2 className="font-lato not-italic font-semibold text-[16px] leading-[150%] text-[#101828] my-3">Sessions </h2>
          </div>

          <div className="flex gap-2">
            <ClientInput
              placeholder="Search..."
              name="search"
              inputchangehandler={inputchangehandler}
              className="h-9"
            />
            <BtnPrimary
              onClick={() => setDialogOpen(true)}
              className="h-9 flex items-center justify-center px-3 gap-1"
            >
              Add Session
              <svg
                width="21"
                height="20"
                viewBox="0 0 21 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.712 4.167v11.666M4.878 10h11.667"
                  stroke="#fff"
                  strokeWidth="1.667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </BtnPrimary>
          </div>
        </div>


        <SessionList
          sampleData={filteredData}
          currentPage={filterpage}
          pageLimit={filterlimit}
          scienceId={science_id}
          loading={loading}
          onRefresh={() => dispatch(getScienceOfSelfSessions({
            science_id,
            page: filterpage,
            limit: filterlimit,
            search: getFilterData.search
          }))}
        />

        <AddEditSession
          dialogOpen={dialogOpen}
          onDialogClose={() => setDialogOpen(false)}
          onSessionAdded={() => {
            if (science_id) {
              dispatch(getScienceOfSelfSessions({
                science_id,
                page: filterpage,
                limit: filterlimit,
                search: getFilterData.search
              }));
            }
          }}
        />

        <div className="flex justify-between items-center mt-3">
          {/* Left side - Pagination info */}
          <Pagination
            totalCount={countData}
            pageNumber={filterpage}
            displayPage={filteredData?.length}
            UpdatePageLimit={setfilterlimit}
            UpdatePage={setfilterpage}
          />

          {/* Right side - Modern Pagination Controls */}
          {countData > 0 && totalPages > 1 && (
            <ModernPagination
              totalPages={totalPages}
              currentPage={filterpage}
              onPageChange={handlePageChange}
            />
          )}
        </div></ToolManagmentCard>

    </React.Fragment>
  )
}

export default SessionMaster;